import React from 'react';
import './commontab.scss';

const CommonTabs = ({ tabs, setHrefData, hrefData }) => {

    const handleTabClick = (href) => {
        setHrefData(href)
        const element = document.getElementById(href);
        if (element) {
            const offset = 100;
            const elementPosition = element.offsetTop - offset;
            window.scrollTo({
                top: elementPosition,
                behavior: 'smooth'
            });
        }
    };
    


    return (
        <div className="common-tabs" style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}>
            {tabs.map((tab, index) => (
                <button
                    key={tab.id}
                    className={tab.href === hrefData ? 'active' : ''}
                    onClick={() => handleTabClick(tab.href)}
                >
                    <span>{tab.label}</span>
                </button>
            ))}
        </div>
    );
};

export default CommonTabs;
